// src/components/Blocks/PhotoGallery/Data.jsx
import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import { injectIntl } from 'react-intl';

const PhotoGalleryData = (props) => {
  const { data, block, onChangeBlock, schema } = props;

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default injectIntl(PhotoGalleryData);